import { EventTrigger } from '@cobliteam/common-types';

import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';

const useImpactEvent = () => {
  const { videoImpactEvent } = useFeatureFlags();

  const isEventTriggerEnabled = (eventTrigger: EventTrigger) => {
    switch (eventTrigger) {
      case EventTrigger.COLLISION:
        return videoImpactEvent;
      default:
        return true;
    }
  };

  return {
    isEventTriggerEnabled,
    videoImpactEvent,
  };
};

export default useImpactEvent;
